<mat-card appearance="outlined" class="card">
  @if (editMode) {
  <mat-card-title mat-dialog-title i18n>Edit Directory</mat-card-title>
  } @if (!editMode) {
  <mat-card-title mat-dialog-title i18n>Enter New Directory</mat-card-title>
  }

  <mat-card-content>
    <form [formGroup]="form">
      <div class="flex-col space-between-none">
        @if (data.type === LibraryT.PUBLIC ) {
        <mat-form-field style="flex: 1 1">
          <mat-label i18n="@@directory">Parent Directory</mat-label>
          <mat-select formControlName="parentUuid">
            <mat-option [value]="null">.</mat-option>
            @for (parent of (directories$ | async); track parent) {
            <mat-option [value]="parent.uuid">{{ parent.name }}</mat-option>
            }
          </mat-select>
          <button matSuffix matIconButton aria-label="Clear">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        } @if (data.type === LibraryT.PERSONAL ) {
        <mat-form-field style="flex: 1 1">
          <mat-label i18n="@@personalFolder">Personal Folder</mat-label>
          <mat-select
            formControlName="relatedObjectUuid"
            (selectionChange)="onPersonalFolderChange($event)"
          >
            <mat-option [value]="null">.</mat-option>
            @for (srvmen of (usersService.servicemen$| async); track srvmen) {
            <mat-option [value]="srvmen.uuid">{{ srvmen.name }}</mat-option>
            }
          </mat-select>
          <button matSuffix matIconButton aria-label="Clear">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        }
        <mat-form-field style="flex: 1 1 70%">
          <mat-label i18n>Name</mat-label>
          <input matInput formControlName="name" />
        </mat-form-field>
        <mat-form-field style="flex: 1 1 70%">
          <mat-label i18n>External Id (opt.)</mat-label>
          <input matInput formControlName="externalId" />
        </mat-form-field>
      </div>
    </form>
  </mat-card-content>
  <mat-card-actions>
    <div class="flex-row end-center gap-20" mat-dialog-actions>
      <button matButton="outlined" (click)="onCloseClick()" i18n="buttonClose">
        Close
      </button>
      <button
        matButton="elevated"
        color="accent"
        (click)="onSave()"
        [disabled]="!form.valid"
        i18n="@@buttonSave"
      >
        Save
      </button>
    </div>
  </mat-card-actions>
</mat-card>
